module.exports = __webpack_public_path__ + "img/franja-asc.f209c222.png";